export default "__VITE_ASSET__3e505b51__"